export const API_URL = process.env.REACT_APP_ITUNES_API;